import React from 'react';
import PropTypes from 'prop-types';
import EditElementFrame from 'contest/components/brief/edit-element-frame';

import BriefStore from 'contest/stores/brief-store';
import TooltipStore from 'contest/stores/TooltipStore';
import briefSaveElementAction from 'contest/actions/brief-save-element';

import { connectToStores } from 'fluxible-addons-react';

export const ConnectedEditElementFrame = connectToStores(
    EditElementFrame,
    [BriefStore],
    (context, props) => {
        const store = context.getStore(BriefStore);
        const onRetry = () => {
            context.executeAction(briefSaveElementAction, {
                section: props.sectionKey,
                element: props.elementKey,
            });
        };
        const element = store.outline[props.sectionKey].elements[props.elementKey];
        const title = element.trans.editingTitle || element.trans.title;
        const titleTooltip = context.getStore(TooltipStore).getForKey(props.elementKey);
        return {
            title: (
                <span>
                    {title} {titleTooltip}
                </span>
            ),
            saveState: element.saveState,
            message: element.trans.editingMessage,
            onRetry,
        };
    },
    {
        executeAction: PropTypes.func.isRequired,
    }
);

ConnectedEditElementFrame.propTypes = {
    sectionKey: PropTypes.string.isRequired,
    elementKey: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/connected/connected-edit-element-frame.jsx